import { defineStore } from 'pinia'

export const useProjectStore = defineStore('project', {
  state: () => ({
    projectId: '',
    signupDeadlineDate: '',
    milestones: []
  }),
  persist: true,
  actions: {
    setProject(project) {
      Object.assign(this, project)
    },
    
  },
})